// extracted by mini-css-extract-plugin
export default {"table_sort_up":"header_table_sort_up__RAyzZ","table_sort_down":"header_table_sort_down__AjmVq"};